import React from 'react';
import Loader from '../components/loader';
import HeroHeader from '../components/HeroHeader';
import { Link } from 'react-router-dom';

class NotFoundPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ loading: false });
    }, 100); // Simulate a 3-second loading delay
  }


  render() {
    const breadcrumbs = [
        { label: 'Home', href: '#', isCurrentPage: false },
        { label: 'Pages', href: '#', isCurrentPage: false },
        { label: '404 Error', href: '#', isCurrentPage: true },
      ];

    return <>
      {this.state.loading ? <Loader /> :
        <>
          <HeroHeader  title="Page Not Found" breadcrumbs={breadcrumbs} />
          <div className="container-fluid py-5 wow fadeIn" data-wow-delay="0.1s">
            <div className="container text-center py-5">
                <div className="row justify-content-center">
                    <div className="col-lg-6">
                        <i className="bi bi-exclamation-triangle display-1 text-primary"></i>
                        <h1 className="display-1">404</h1>
                        <h1 className="mb-4">Page Not Found</h1>
                        <p className="mb-4">We’re sorry, the page you have looked for does not exist in our website! Maybe go to our home page or try to use a search?</p>
                        <Link className="btn btn-primary py-3 px-4" href="/">Go Back To Home</Link>
                    </div>
                </div>
            </div>
        </div>
        </>}
    </>
  }
}

export default NotFoundPage;
